import React from 'react';
import PropTypes from 'prop-types';
import { SearchTextInput } from 'web-ui-components/lib/data/filter-and-search';
import { Button } from 'web-ui-components/lib/atoms/buttons';

import AccountPickerToggleAccountsView from './AccountPickerToggleAccountsView';
import accountPickerContent, { contentPropTypes } from './AccountPicker.content';
import { GridListToggle } from 'web-ui-components/lib/layout/content';
import withContent from '../../../containers/withContent';

const AccountPickerHeader = ({
	onShowFavourites,
	onShowAllAccounts,
	onToggleListView,
	showFavourites,
	listViewSelected,
	onSearchTextChange,
	content,
	searchText,
	onSearchTextSubmit,
	pageLoading,
}) => (
	<div data-test-id="account-picker-header" className="account-picker__header">
		<AccountPickerToggleAccountsView
			onShowFavourites={onShowFavourites}
			onShowAllAccounts={onShowAllAccounts}
			showFavourites={showFavourites}
			content={content}
		/>
		<div className="account-picker__header__searchContainer">
			<div
				data-test-id="account-picker-header-searchcontainer-search"
				className="account-picker__header__searchContainer__search"
			>
				<SearchTextInput onChange={onSearchTextChange} value={searchText} placeholder={content.searchPlaceholder} />
				<Button
					type="button"
					disabled={pageLoading || searchText.length < 3}
					display="primary"
					width="flush"
					onClick={onSearchTextSubmit}
				>
					{content.search}
				</Button>
			</div>
			<GridListToggle
				onChange={(checked) => onToggleListView(!checked)}
				name="account-picker-toggle-list-view"
				data-test-id="account-picker-toggle-list-view"
				isListViewSelected={listViewSelected}
			/>
		</div>
	</div>
);

AccountPickerHeader.propTypes = {
	onShowFavourites: PropTypes.func.isRequired,
	onShowAllAccounts: PropTypes.func.isRequired,
	showFavourites: PropTypes.bool.isRequired,
	listViewSelected: PropTypes.bool.isRequired,
	onSearchTextChange: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes),
	onToggleListView: PropTypes.func.isRequired,
	searchText: PropTypes.string.isRequired,
	onSearchTextSubmit: PropTypes.func.isRequired,
	pageLoading: PropTypes.bool.isRequired,
};

export default withContent({ content: accountPickerContent })(AccountPickerHeader);
